export { default as useUniversalFilterTextPlainFilterState } from './useUniversalFilterTextPlainFilterState';
